import * as React from "react";

import PropTypes from "prop-types";
import { Button, Modal } from "semantic-ui-react";

import styles from "./ExistingEmailModal.module.css";
import SkipButton from "../../SkipButton";

const { useState } = React;
 
function ExistingEmailModal({
  visibility,
  onOpenModal,
  onCloseModal,
}) {

  return (
    <Modal
      size="small"
      centered={true}
      open={visibility}
      onOpen={onOpenModal}
      onClose={onCloseModal}
      closeOnDimmerClick={false}
    >
      <div className={styles.modalContainer}>
        <Button
          className={styles.closeButton}
          onClick={onCloseModal}
          size="big"
          icon="close"
        />

        <text className={styles.headerText}>
          Error: This email is already registered. Please choose another one.
        </text>

        <div className={styles.buttonGroup}>
          <button className={styles.nextTipButton} onClick={onCloseModal}>
            Yes
          </button>

          <SkipButton onClick={onCloseModal} buttonText="No" />
        </div>
      </div>
		
    </Modal>
  );
}

ExistingEmailModal.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default ExistingEmailModal;
